<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >技术组审核</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入开发编号、数字员工名称"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.allStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 140px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column
                            align="center"
                            title="审批"
                            width="100"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="row.Status === '1'"
                                    status="success"
                                    icon="fa fa-check"
                                    round
                                    @click="auditRowEvent(row)"
                                    >审批
                                </vxe-button>
                                <vxe-button
                                    v-else
                                    icon="vxe-icon-search"
                                    status="info"
                                    round
                                    @click="viewRowEvent(row)"
                                    >查看
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column align="center" title="状态" width="120">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.AuditStatus }}</vxe-button
                                >
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="PubState"
                            title="发布阶段"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessID"
                            title="开发编号"
                            width="140"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="数字员工名称"
                            width="250"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empTypeName"
                            title="数字员工类型"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="introduction"
                            title="数字员工简介"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="业务人员"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="techName"
                            title="辅导老师"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="sceneName"
                            title="场景组担当"
                            width="140"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="申请时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="AuditTime"
                            title="审批时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManSingleTime"
                            title="Before-人工每次耗时(分钟)"
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="ManFrequency"
                            title="Before-人工每月次数"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="RobotSingleTime"
                            title="After-每次耗时(分钟)"
                            width="200"
                            sorable
                        ></vxe-column>
                        <vxe-column
                            field="RobotMonthRun"
                            title="After-每月次数"
                            width="140"
                        ></vxe-column>
                        <vxe-column
                            field="DevelopTime"
                            title="流程开发时间(小时)"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="SingleSaveTime"
                            title="单次节省-时间(分钟)"
                            show-overflow
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="realPlatformName"
                            title="部署平台"
                            width="100"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="CreateMan"
                            title="创建人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreateManEmail"
                            title="创建人邮箱"
                            width="180"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserID"
                            title="UserID"
                            show-overflow
                            width="100"
                            :visible="false"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!--审核界面 -->
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="840"
                height="600"
                show-zoom
                resize
                remember
                show-footer
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="开发编号"
                            field="reqNo"
                            span="10"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.ProcessID"
                                    placeholder="请选择开发编号"
                                    :disabled="formInput.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button disabled>选择 </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工名称"
                            field="ProcessName"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.ProcessName"
                                    placeholder="请输入数字员工名称"
                                    :disabled="formInput.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="工作场景描述"
                            field="processDesc"
                            span="24"
                            title-width="120px"
                        >
                            <vxe-textarea
                                v-model="formInput.formData.processDesc"
                                placeholder="填写（流程、痛点、解决方案）"
                                maxlength="500"
                                show-word-count
                                readonly
                                :disabled="formInput.allInputDisable"
                            ></vxe-textarea>
                        </vxe-form-item>
                        <vxe-form-item
                            title="场景业务价值"
                            field="sceneBussValue"
                            span="24"
                            title-width="120px"
                        >
                            <vxe-textarea
                                v-model="formInput.formData.sceneBussValue"
                                placeholder="填写（体验、收益、效率、效果）"
                                maxlength="500"
                                readonly
                                show-word-count
                                :disabled="formInput.allInputDisable"
                            ></vxe-textarea>
                        </vxe-form-item>

                        <vxe-form-item
                            title="申请人(孵化者)"
                            field="CreateManName"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.CreateManName"
                                    placeholder="请输入姓名"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总部"
                            field="division"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.division"
                                    placeholder="请输入总部"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工类型"
                            field="empType"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.empType"
                                    :options="formInput.digitalTypes"
                                    placeholder="请选择数字员工类型"
                                    readonly
                                    disabled
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工简介"
                            field="introduction"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.introduction"
                                    clearable
                                    placeholder="请输入数字员工简介"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="辅导老师"
                            field="techUID"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.techUID"
                                    :options="formInput.allTechs"
                                    placeholder="请选择辅导老师"
                                    disabled
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="场景组担当"
                            field="sceneUID"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.sceneUID"
                                    :options="formInput.allScenes"
                                    placeholder="请选择场景组担当"
                                    disabled
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务人员"
                            field="UserNameEmail"
                            span="10"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.UserNameEmail"
                                    readonly
                                    placeholder="请选择业务人员"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button disabled>选择</vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="发布阶段"
                            field="PubState"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.PubState"
                                    placeholder="请选择发布阶段"
                                    disabled
                                    clearable
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试发布"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="生产发布"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="部署平台"
                            field="realPlatform"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.realPlatform"
                                    :options="formInput.planPlatform"
                                    placeholder="请选择部署平台"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            :title="otherPlatformLabel"
                            field="otherPlatform"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.otherPlatform"
                                    clearable
                                    :placeholder="otherPlatformLabel"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="外部AppID"
                            field="otherAppID"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.otherAppID"
                                    clearable
                                    placeholder="请输入外部AppID.例如Dify应用ID"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工版本"
                            field="empVersion"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.empVersion"
                                    clearable
                                    placeholder="请输入数字员工版本"
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            :visible="isDifyDE"
                            title="公开范围"
                            field="difyViewType"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.difyViewType"
                                    placeholder="请选择发公开范围"
                                    :disabled="formInput.allInputDisable"
                                    empty-value=""
                                    @change="onDifyViewTypeChange"
                                    @clear="
                                        formInput.formData.difyViewType = ''
                                    "
                                >
                                    <vxe-option
                                        value="1"
                                        label="个人"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="总部"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="全部"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            :visible="isDifyDE"
                            title="公开总部"
                            field="difyViewDivsion"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.difyViewDivsion"
                                    placeholder="请选择公开总部"
                                    :disabled="formInput.allInputDisable"
                                    clearable
                                    multiple
                                    empty-value=""
                                    @clear="
                                        formInput.formData.difyViewDivsion = ''
                                    "
                                    :options="formInput.hqOptions"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="运行方式"
                            field="deployType"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.deployType"
                                    placeholder="请选择运行方式"
                                    :disabled="formInput.allInputDisable"
                                    @change="onSelectDeployType"
                                >
                                    <vxe-option
                                        value="平台"
                                        label="平台"
                                    ></vxe-option>
                                    <vxe-option
                                        value="本地"
                                        label="本地"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="版本变更备注"
                            field="verHistory"
                            span="12"
                            title-width="120px"
                            v-if="false"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.verHistory"
                                    clearable
                                    placeholder="请输入版本变更备注"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="本地运行原因"
                            field="localReason"
                            span="24"
                            title-width="120px"
                            :visible="isShowDeployType"
                        >
                            <template #default>
                                <vxe-textarea
                                    v-model="formInput.formData.localReason"
                                    placeholder="请输入本地运行原因"
                                    maxlength="1000"
                                    show-word-count
                                    :disabled="formInput.allInputDisable"
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="本地程序类型"
                            field="localAppType"
                            span="12"
                            title-width="120px"
                            :visible="isShowDeployType"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.localAppType"
                                    placeholder="请选择本地程序类型"
                                    :disabled="formInput.allInputDisable"
                                    @change="onSelectLocalAppType"
                                >
                                    <vxe-option
                                        v-for="option in localAppTypeOptions"
                                        :key="option.value"
                                        :value="option.value"
                                        :label="option.label"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="12" :item-render="{}">
                            <a
                                href="javascript:void(0);"
                                @click="viewInstructions"
                                >填写说明</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            :title="localAppPathLabel"
                            field="localAppPath"
                            span="22"
                            title-width="120px"
                            :visible="isShowDeployType && isShowLocalAppPath"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.localAppPath"
                                    :placeholder="localAppPlaceholder"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title=""
                            span="2"
                            :item-render="{}"
                            :visible="isShowDeployType && isShowLocalAppPath"
                        >
                            <template #default="">
                                <vxe-button
                                    :disabled="true"
                                    @click="insertLocalAppPath"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            :title="localExeFileLabel"
                            field="localExeFile"
                            span="22"
                            title-width="120px"
                            :visible="isShowDeployType && isShowLocalExeFile"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.localExeFile"
                                    :placeholder="localFilePlaceholder"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title=""
                            span="2"
                            :item-render="{}"
                            :visible="isShowDeployType && isShowLocalExeFile"
                        >
                            <template #default="">
                                <vxe-button
                                    :disabled="true"
                                    @click="insertLocalExeFile"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            :title="localExeParamLabel"
                            field="localExeParam"
                            span="22"
                            title-width="120px"
                            :visible="isShowDeployType && isShowLocalExeParam"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.localExeParam"
                                    placeholder="请输入程序参数"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="生产发布填写"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-list-alt' }"
                        ></vxe-form-item>

                        <vxe-form-item
                            title="Before-人工每次耗时(分钟)"
                            field="ManSingleTime"
                            span="12"
                            title-width="210px"
                            :title-prefix="{
                                content:
                                    '人工每次执行的耗时（仅限于数字员工执行任务的部分）,请谨慎填写，该字段直接影响该数字员工的等效工时',
                                icon: 'vxe-icon-question-circle-fill',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.ManSingleTime"
                                    placeholder="请输入Before-人工每次耗时(分钟)"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="Before-人工每月次数"
                            field="ManFrequency"
                            span="12"
                            title-width="200px"
                            :title-prefix="{
                                content: '人工每月执行次数（未实现数字员工前）',
                                icon: 'vxe-icon-question-circle-fill',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.ManFrequency"
                                    placeholder="请输入Before-人工每月次数"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="After-每次耗时(分钟)"
                            field="RobotSingleTime"
                            span="12"
                            title-width="210px"
                            :title-prefix="{
                                content: '数字员工单次执行任务的耗时',
                                icon: 'vxe-icon-question-circle-fill',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.RobotSingleTime"
                                    placeholder="请输入After-每次耗时(分钟)"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="After-每月次数"
                            field="RobotMonthRun"
                            span="12"
                            title-width="200px"
                            :title-prefix="{
                                content:
                                    '数字员工每月计划执行次数（含定时任务、接口调用、人工驱动等）',
                                icon: 'vxe-icon-question-circle-fill',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.RobotMonthRun"
                                    placeholder="请输入After-每月次数"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="单次节省-时间(分钟)"
                            field="SingleSaveTime"
                            span="12"
                            title-width="210px"
                            :title-prefix="{
                                content:
                                    '自动计算，人工单次耗时-数字员工单次耗时',
                                icon: 'vxe-icon-question-circle-fill',
                            }"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.SingleSaveTime"
                                    placeholder="请输入单次节省-时间(分钟)"
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="开发时长(小时)"
                            field="DevelopTime"
                            span="12"
                            title-width="200px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.DevelopTime"
                                    placeholder="请输入流程开发时间"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="定时执行时间"
                            field="ExecBegin"
                            span="12"
                            title-width="210px"
                        >
                            <template #default>
                                <vxe-input
                                    type="text"
                                    clearable
                                    v-model="formInput.formData.ExecBegin"
                                    placeholder="例:08:30"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="-"
                            field="ExecEnd"
                            span="6"
                            title-width="30px"
                        >
                            <template #default>
                                <vxe-input
                                    type="text"
                                    clearable
                                    v-model="formInput.formData.ExecEnd"
                                    placeholder="例:17:30"
                                    readonly
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="总任务节点数"
                            field="operationNodes"
                            span="12"
                            title-width="210px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.operationNodes"
                                    type="number"
                                    min="0"
                                    clearable
                                    placeholder="请输入总任务节点数"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工替代节点数"
                            field="replaceNodes"
                            span="10"
                            title-width="200px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.replaceNodes"
                                    type="number"
                                    min="0"
                                    clearable
                                    placeholder="请输入数字员工替代节点数"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1737"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                说明
                            </a>
                        </vxe-form-item>
                        <vxe-form-item
                            title="附件"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-paperclip' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="程序包"
                            field="fPathPackage"
                            span="18"
                            :item-render="{}"
                            title-width="120px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPackage"
                                    placeholder="请选择程序包"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="formInput.allInputDisable"
                                    @click="insertPackageEvent"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="4" :item-render="{}">
                            <a
                                v-if="isShowPackageLink"
                                href="javascript:void(0);"
                                @click="downloadFile(1)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            title="设计文档"
                            field="fPathPdd"
                            span="18"
                            :item-render="{}"
                            title-width="120px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPdd"
                                    placeholder="请选择设计文档"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="formInput.allInputDisable"
                                    @click="insertPDDEvent"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="isShowPDDLink"
                                href="javascript:void(0);"
                                @click="downloadFile(2)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="!isShowPDDLink"
                                href="javascript:void(0);"
                                @click="downloadFile(4)"
                                >模板</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            title="数字员工照片"
                            field="fPathPhoto"
                            span="18"
                            :item-render="{}"
                            title-width="120px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPhoto"
                                    placeholder="请选择数字员工照片"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                >
                                    浏览
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="isShowPhotoLink"
                                href="javascript:void(0);"
                                @click="downloadFile(6)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                        </vxe-form-item>
                        <vxe-form-item
                            span="24"
                            title-align="left"
                            title-width="600px"
                            :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                            v-if="formInput.formData.AuditStatus == '1'"
                        >
                            <template #title>
                                <span style="color: red">审核意见</span>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="虚拟机"
                            field="MachineName"
                            span="24"
                            title-width="100px"
                            v-if="
                                formInput.formData.AuditStatus == '1' &&
                                (formInput.formData.realPlatform == 'PT001' ||
                                    formInput.formData.realPlatform ==
                                        'PT002' ||
                                    formInput.formData.realPlatform == 'PT005')
                            "
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.MachineName"
                                    :options="toolbar.macOptions"
                                    placeholder="请选择虚拟机"
                                    clearable
                                    transfer
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            span="24"
                            v-if="formInput.formData.AuditStatus == '1'"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="auditOpinion"
                                    placeholder="请输入审核意见"
                                    maxlength="1000"
                                    show-word-count
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
                <template #footer v-if="isViewFooter">
                    <div style="text-align: center; width: 100%">
                        <vxe-button
                            @click="reject"
                            icon="fa fa-reply"
                            status="danger"
                            >驳回
                        </vxe-button>
                        <vxe-button
                            @click="submit"
                            :loading="submitLoading"
                            icon="fa fa-check"
                            status="success"
                            >通过
                        </vxe-button>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import MyAuditLine from "../myPlug/MyAuditLine";

export default {
    name: "TechAudit",
    components: { MyAuditLine },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const toolbar = reactive({
            loading: false,
            macOptions: [],
            allStatus: [],
            formData: {
                status: "1",
                searchKey: "",
            },
        });

        const formInput = reactive({
            title: "技术组审核",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            processIDReadonly: true,
            userSelType: 2, //1 开发人员 2 业务人员
            allTechs: [], //技术组担当
            allScenes: [], //场景组担当
            planPlatform: [], //部署平台
            digitalTypes: [], //员工类型
            hqOptions: [], //所有总部
            formData: {
                Id: "",
                AuditStatus: "0",
                reqNo: "", //需求编号
                ProcessName: "",
                ProcessID: "",
                processDesc: "",
                sceneBussValue: "",
                CreateMan: "",
                CreateManName: "",
                division: "",
                empType: "",
                introduction: "",
                techUID: "",
                techName: "",
                sceneUID: "",
                sceneName: "",
                UserName: "",
                UserNameEmail: "",
                UserId: "",
                UserIDName: [],
                realPlatform: "", //部署平台
                otherPlatform: "", //其他部署平台
                PubState: "",
                empVersion: "", //数字员工版本
                ManSingleTime: "",
                ManFrequency: "",
                DevelopTime: "",
                RobotSingleTime: "",
                RobotMonthRun: "",
                SingleSaveTime: "",
                otherAppID: "",
                verHistory: "",
                MachineName: "",
                fPathPackage: "",
                fPathPdd: "",
                fPathPhoto: "",
                ExecBegin: "",
                ExecEnd: "",
                isPro: false, //是否生产发布
                difyViewType: "",
                difyViewDivsion: "",
                deployType: "",
                localReason: "",
                localAppPath: "",
                localExeFile: "",
                localExeParam: "",
                localAppType: "", //本地程序类型 1 python 2 exe 3excel
                operationNodes: "", //操作节点数
                replaceNodes: "",
            },
            formRules: {
                reqNo: [{ required: false, message: "需求编号不能为空" }],
                ProcessName: [
                    { required: true, message: "数字员工名称不能为空" },
                ],
                processDesc: [
                    { required: false, message: "工作场景描述不能为空" },
                ],
                sceneBussValue: [
                    { required: false, message: "场景业务价值不能为空" },
                ],
                empType: [{ required: true, message: "数字员工类型不能为空" }],
                introduction: [
                    { required: true, message: "数字员工简介不能为空" },
                ],
                techUID: [{ required: true, message: "辅导老师不能为空" }],
                sceneUID: [{ required: false, message: "场景组担当不能为空" }],
                UserNameEmail: [
                    { required: true, message: "业务人员不能为空" },
                ],
                PubState: [{ required: true, message: "发布阶段不能为空" }],
                empVersion: [
                    { required: true, message: "数字员工版本不能为空" },
                ],
                realPlatform: [{ required: true, message: "部署平台不能为空" }],
                otherPlatform: [{ required: false, message: "不能为空" }],
                ManSingleTime: [
                    {
                        required: false,
                        message: "Before-人工每次耗时(分钟)不能为空",
                    },
                ],
                ManFrequency: [
                    { required: false, message: "Before-人工每月次数不能为空" },
                ],
                DevelopTime: [{ required: false, message: "开发时长不能为空" }],
                RobotSingleTime: [
                    {
                        required: false,
                        message: "After-每次耗时(分钟)不能为空",
                    },
                ],
                RobotMonthRun: [
                    { required: false, message: "After-每月次数不能为空" },
                ],
                otherAppID: [{ required: false, message: "外部AppID不能为空" }],
                verHistory: [
                    { required: false, message: "版本变更备注不能为空" },
                ],
                fPathPackage: [{ required: true, message: "程序包不能为空" }],
                fPathPdd: [{ required: true, message: "设计文档不能为空" }],
                fPathPhoto: [
                    { required: false, message: "数字员工照片不能为空" },
                ],
                difyViewType: [
                    { required: false, message: "Dify员工公开范围不能为空" },
                ],
                difyViewDivsion: [
                    { required: false, message: "公开总部不能为空" },
                ],
                deployType: [{ required: true, message: "运行方式不能为空" }],
                localReason: [
                    { required: false, message: "本地运行原因不能为空" },
                ],
                localAppPath: [
                    { required: false, message: "本地应用程序路径不能为空" },
                ],
                localExeFile: [
                    { required: false, message: "本地可执行文件不能为空" },
                ],
                localExeParam: [
                    { required: false, message: "本地可执行文件参数不能为空" },
                ],
                localAppType: [
                    { required: false, message: "本地程序类型不能为空" },
                ],
                operationNodes: [
                    { required: false, message: "操作节点数不能为空" },
                ],
                replaceNodes: [
                    { required: false, message: "替代节点数不能为空" },
                ],
            },
        });

        const auditOpinion = ref("OK");
        const localAppTypeOptions = [
            {
                value: "1",
                label: "Python程序文件(.py)",
                tip: "",
            },
            {
                value: "2",
                label: "可执行文件(.exe)",
                tip: "",
            },
            {
                value: "3",
                label: "Excel宏(.xlsm、VBA等)",
                tip: "",
            },
            {
                value: "5",
                label: "其他编程语言",
                tip: "如 MATLAB、PLC、Android、TypeScript、VBS、.Net、Java等，请在【开发工具或语言】描述技术实现方式",
            },
            {
                value: "6",
                label: "咚咚应用",
                tip: "如咚咚AI表格、AI助理、咚咚OA审批流、Deap平台等，请在【外部AppID】填写访问链接",
            },
            {
                value: "7",
                label: "智能体",
                tip: "使用AI应用开发平台（如Coze、友答、AI Works、悟空等）创建的工作流、智能体、聊天助手等应用，请在【外部AppID】填写访问链接",
            },
            {
                value: "8",
                label: "其他业务系统",
                tip: "业务自主建设的应用系统（如网站、后台服务）等，请在【外部AppID】填写访问链接",
            },
            {
                value: "4",
                label: "其他",
                tip: "未在上述选项中，请在【开发工具或语言】描述技术实现方式",
            },
        ];
        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            formInput,
            dtUser: null,
            iShowSelectUser: ref(false),
            onePackageFile: {}, //上传的附件
            isShowPackageLink: false,
            isShowPDDLink: false,
            isShowPhotoLink: false,
            isShowPPDLink: false,
            submitLoading: false,
            auditOpinion,
            dtAudit: [],
            isShowAuditList: false,
            tableHeight: 0,
            isViewFooter: true,
            isDifyDE: false,
            isShowDeployType: false,
            otherPlatformLabel: "其他部署平台",
            localAppPathLabel: ref("Python.exe路径"),
            localExeFileLabel: ref("Python文件"),
            localExeParamLabel: ref("程序执行参数"),
            localAppPlaceholder: ref(
                "Python.exe 路径(如：C:\\Python\\python.exe)"
            ),
            localFilePlaceholder: ref(
                "Python脚本 路径(如：C:\\Python\\script.py)"
            ),
            isShowLocalExeFile: ref(false), //是否显示本地执行文件
            isShowLocalExeParam: ref(false), //是否显示本地执行参数
            isShowLocalAppPath: ref(false), //是否显示本地应用程序路径
            localAppTypeOptions,
        };
    },
    methods: {
        onSelectPubState() {
            //测试发布
            if (this.formInput.formData.PubState === "1") {
                this.formInput.formData.isPro = false;
                if (this.editType == "1") {
                    //新增时校验
                    //派神易 uipath python
                    if (
                        ["PT001", "PT002", "PT005"].includes(
                            this.formInput.formData.realPlatform
                        )
                    ) {
                        this.formInput.formRules.fPathPackage[0].required = true;
                        this.formInput.formRules.fPathPdd[0].required = true;
                    } else {
                        this.formInput.formRules.fPathPackage[0].required = false;
                        this.formInput.formRules.fPathPdd[0].required = false;
                    }
                }
                this.formInput.formRules.fPathPhoto[0].required = false;
                this.formInput.formRules.ManSingleTime[0].required = false;
                this.formInput.formRules.ManFrequency[0].required = false;
                this.formInput.formRules.DevelopTime[0].required = false;
                this.formInput.formRules.RobotSingleTime[0].required = false;
                this.formInput.formRules.RobotMonthRun[0].required = false;
                this.formInput.formRules.operationNodes[0].required = false;
                this.formInput.formRules.replaceNodes[0].required = false;
                this.formInput.formData.ManSingleTime = 0;
                this.formInput.formData.ManFrequency = 0;
                this.formInput.formData.DevelopTime = 0;
                this.formInput.formData.RobotSingleTime = 0;
                this.formInput.formData.RobotMonthRun = 0;
            } else {
                this.formInput.formData.isPro = true;

                if (this.editType == "1") {
                    if (
                        ["PT001", "PT002", "PT005"].includes(
                            this.formInput.formData.realPlatform
                        )
                    ) {
                        this.formInput.formRules.fPathPhoto[0].required = true;
                        this.formInput.formRules.fPathPackage[0].required = true;
                        this.formInput.formRules.fPathPdd[0].required = true;
                    } else {
                        this.formInput.formRules.fPathPhoto[0].required = false;
                        this.formInput.formRules.fPathPackage[0].required = false;
                        this.formInput.formRules.fPathPdd[0].required = false;
                    }
                }

                this.formInput.formRules.ManSingleTime[0].required = true;
                this.formInput.formRules.ManFrequency[0].required = true;
                this.formInput.formRules.DevelopTime[0].required = true;
                this.formInput.formRules.RobotSingleTime[0].required = true;
                this.formInput.formRules.RobotMonthRun[0].required = true;
                this.formInput.formRules.operationNodes[0].required = true;
                this.formInput.formRules.replaceNodes[0].required = true;
            }
            //选其他部署平台，就要必填其他部署平台
            this.formInput.formRules.otherPlatform[0].required = [
                "PT003",
                "PT004",
                "PT006",
            ].includes(this.formInput.formData.realPlatform);
            //选Dify就填外部APPID
            this.formInput.formRules.otherAppID[0].required =
                this.formInput.formData.realPlatform === "PT003";
            if (this.formInput.formData.realPlatform === "PT003") {
                this.otherPlatformLabel = "Dify链接";
            } else if (this.formInput.formData.realPlatform === "PT004") {
                this.otherPlatformLabel = "Outsystem链接";
            } else {
                this.otherPlatformLabel = "开发工具或语言";
            }
            this.isDifyDE = this.formInput.formData.realPlatform === "PT003";
            this.formInput.formRules.difyViewType[0].required =
                this.formInput.formData.realPlatform === "PT003";
            this.formInput.formRules.difyViewDivsion[0].required =
                this.formInput.formData.difyViewType === "2";
            if (this.formInput.formData.deployType === "平台") {
                this.formInput.formRules.localReason[0].required = false;
                this.formInput.formRules.localAppType[0].required = false;
                this.formInput.formData.localReason = "";
                this.isShowDeployType = false;
            } else if (this.formInput.formData.deployType === "本地") {
                this.formInput.formRules.localReason[0].required = true;
                this.formInput.formRules.localAppType[0].required = true;
                this.isShowDeployType = true;
            }
            this.onSelectLocalAppType();
        },
        onSelectLocalAppType() {
            if (this.formInput.formData.localAppType === "1") {
                this.localAppPathLabel = "Python.exe路径";
                this.localExeFileLabel = "Python文件";
                this.localExeParamLabel = "程序执行参数";
                this.localAppPlaceholder =
                    "Python.exe 路径(如：C:\\Python\\python.exe)";
                this.localFilePlaceholder =
                    "Python脚本 路径(如：C:\\Python\\script.py)";
                this.isShowLocalExeFile = true;
                this.isShowLocalExeParam = true;
                this.isShowLocalAppPath = true;
                this.formInput.formRules.localAppPath[0].required = true;
                this.formInput.formRules.localExeFile[0].required = true;
            } else if (this.formInput.formData.localAppType === "2") {
                //Exe
                this.localAppPathLabel = "Exe程序路径";
                this.localExeFileLabel = "Exe程序路径";
                this.localExeParamLabel = "程序执行参数";
                this.localAppPlaceholder =
                    "Exe程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
                this.localFilePlaceholder =
                    "Exe程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
                this.formInput.formData.localExeFile = "";
                this.isShowLocalExeFile = false;
                this.isShowLocalExeParam = true;
                this.isShowLocalAppPath = true;
                this.formInput.formRules.localAppPath[0].required = true;
                this.formInput.formRules.localExeFile[0].required = false;
            } else if (this.formInput.formData.localAppType === "3") {
                //Excel
                this.localAppPathLabel = "Excel程序路径";
                this.localExeFileLabel = "Excel文件";
                this.localExeParamLabel = "Excel参数";
                this.localAppPlaceholder =
                    "Excel程序路径(如：C:\\Program Files\\MyApp\\Excel.exe)";
                this.localFilePlaceholder =
                    "Excel文件路径(如：C:\\Program Files\\MyApp\\file.xlsx)";
                this.formInput.formData.localExeParam = "";
                this.isShowLocalExeFile = true;
                this.isShowLocalExeParam = false;
                this.isShowLocalAppPath = true;
                this.formInput.formRules.localAppPath[0].required = true;
                this.formInput.formRules.localExeFile[0].required = true;
            } else {
                //其他
                this.localAppPathLabel = "程序路径";
                this.localExeFileLabel = "文件路径";
                this.localExeParamLabel = "执行参数";
                this.localAppPlaceholder =
                    "程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
                this.localFilePlaceholder =
                    "文件路径(如：C:\\Program Files\\MyApp\\file.exe)";
                this.formInput.formData.localExeParam = "";
                this.formInput.formData.localAppPath = "";
                this.formInput.formData.localExeFile = "";
                this.isShowLocalExeFile = false;
                this.isShowLocalExeParam = false;
                this.isShowLocalAppPath = false;
                this.formInput.formRules.localAppPath[0].required = false;
                this.formInput.formRules.localExeFile[0].required = false;
            }
            if (this.formInput.formData.deployType === "本地") {
                if (
                    this.formInput.formData.localAppType === "5" ||
                    this.formInput.formData.localAppType === "4"
                ) {
                    this.formInput.formRules.otherPlatform[0].required = true;
                    this.formInput.formRules.otherAppID[0].required = false;
                } else if (this.formInput.formData.localAppType === "6") {
                    this.formInput.formRules.otherAppID[0].required = true;
                    this.formInput.formRules.otherPlatform[0].required = false;
                } else if (this.formInput.formData.localAppType === "7") {
                    this.formInput.formRules.otherAppID[0].required = true;
                    this.formInput.formRules.otherPlatform[0].required = false;
                } else if (this.formInput.formData.localAppType === "8") {
                    this.formInput.formRules.otherAppID[0].required = true;
                    this.formInput.formRules.otherPlatform[0].required = false;
                } else {
                    this.formInput.formRules.otherPlatform[0].required = false;
                    this.formInput.formRules.otherAppID[0].required = false;
                }
            } else {
                this.formInput.formRules.otherPlatform[0].required = false;
                this.formInput.formRules.otherAppID[0].required = false;
            }
        },
        onDifyViewTypeChange() {
            this.formInput.formRules.difyViewDivsion[0].required =
                this.formInput.formData.difyViewType === "2";
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    "",
                    this.toolbar.formData.status,
                ], //技术审核中
            };
            this.$api.newPublishManageAPI
                .getPublishList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        //审核记录
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;

                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPC(pctype) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [pctype], //
            };
            this.$api.systemManageAPI
                .getMachineListByType(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.RobotName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
        },

        //审核数据
        auditRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };

            this.$api.newPublishManageAPI
                .getPublishOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data;
                    this.formInput.formData.difyViewDivsion =
                        res.data.Data.difyViewDivsion.split(",");

                    this.onSelectPubState();
                    //派神易,uipath
                    if (
                        this.formInput.formData.realPlatform === "PT001" ||
                        this.formInput.formData.realPlatform === "PT002"
                    ) {
                        this.bindPC("0");
                        // python
                    } else if (
                        this.formInput.formData.realPlatform === "PT005"
                    ) {
                        this.bindPC("1");
                    }
                    this.checkHasFiles();
                    this.formInput.formRules.fPathPackage[0].required = false;
                    this.formInput.formRules.fPathPdd[0].required = false;
                    this.formInput.formRules.fPathPhoto[0].required = false;

                    this.editType = "2"; //更新
                    this.formInput.allInputDisable = false;
                    this.formInput.saveButDisable = true;
                    this.formInput.title = "上岗申请-技术组审核";
                    this.isViewFooter = true;

                    const userIds =
                        this.formInput.formData.UserId.toString().split(";");
                    const userNames =
                        this.formInput.formData.UserNameEmail.toString().split(
                            ";"
                        );
                    this.formInput.formData.UserIDName = userIds.map(
                        (id, i) => ({
                            Name: userNames[i],
                            ID: id,
                        })
                    );
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        viewRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };

            this.$api.newPublishManageAPI
                .getPublishOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData = res.data.Data;

                    this.formInput.formData.difyViewDivsion =
                        res.data.Data.difyViewDivsion.split(",");

                    this.onSelectPubState();
                    //派神易,uipath
                    if (
                        this.formInput.formData.realPlatform === "PT001" ||
                        this.formInput.formData.realPlatform === "PT002"
                    ) {
                        this.bindPC("0");
                        // python
                    } else if (
                        this.formInput.formData.realPlatform === "PT005"
                    ) {
                        this.bindPC("1");
                    }
                    this.checkHasFiles();
                    this.formInput.formRules.fPathPackage[0].required = false;
                    this.formInput.formRules.fPathPdd[0].required = false;
                    this.formInput.formRules.fPathPhoto[0].required = false;

                    this.editType = "2"; //更新
                    this.formInput.allInputDisable = true;
                    this.formInput.saveButDisable = true;
                    this.formInput.title = "查看上岗申请";
                    this.isViewFooter = false;

                    let count =
                        this.formInput.formData.UserId.toString().split(
                            ";"
                        ).length;
                    this.formInput.formData.UserIDName = [];
                    for (let i = 0; i < count; i++) {
                        this.formInput.formData.UserIDName.push({
                            Name: this.formInput.formData.UserNameEmail.toString().split(
                                ";"
                            )[i],
                            ID: this.formInput.formData.UserId.toString().split(
                                ";"
                            )[i],
                        });
                    }
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeWinEvent() {
            this.findData();
        },
        selectUser() {
            this.toolbar.formData.searchKey = "";
            this.findUserData();
            this.iShowSelectUser = true;
        },

        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        downloadFile(type) {
            this.$api.fileManageAPI
                .downloadPublishFile(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: type,
                    })
                )
                .then(async (res) => {
                    const contentType = res.headers["content-type"] || "";

                    // 后端返回错误JSON
                    if (contentType.includes("application/json")) {
                        const text = await res.data.text();

                        try {
                            const result = JSON.parse(text);

                            VXETable.modal.alert({
                                content: result.Message || "下载失败",
                                status: "error",
                            });
                        } catch (e) {
                            VXETable.modal.alert({
                                content: text,
                                status: "error",
                            });
                        }

                        return;
                    }

                    let fileName = "下载文件";

                    const disposition =
                        res.headers["content-disposition"] ||
                        res.headers["Content-Disposition"];

                    if (disposition) {
                        const utf8Match = disposition.match(
                            /filename\*=UTF-8''([^;]+)/i
                        );

                        const normalMatch =
                            disposition.match(/filename="?([^"]+)"?/i);

                        if (utf8Match && utf8Match[1]) {
                            fileName = decodeURIComponent(utf8Match[1]);
                        } else if (normalMatch && normalMatch[1]) {
                            fileName = decodeURIComponent(normalMatch[1]);
                        }
                    }

                    const blob = new Blob([res.data], {
                        type: contentType || "application/octet-stream",
                    });

                    if (blob.size === 0) {
                        VXETable.modal.alert({
                            content: "文件内容为空",
                            status: "error",
                        });
                        return;
                    }

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = fileName;
                    a.style.display = "none";

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error(error);

                    VXETable.modal.alert({
                        content: "文件下载失败",
                        status: "error",
                    });
                });
        },
        checkHasFiles() {
            this.$api.newPublishManageAPI
                .checkPublishHasFiles(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: "",
                    })
                )
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.alert({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    let fileStatus = res.data.Data.split(",");

                    this.isShowPackageLink = fileStatus[0] === "1";
                    this.isShowPDDLink = fileStatus[1] === "1";
                    this.isShowPhotoLink = fileStatus[2] === "1";
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addAuditRecord(publishid, status) {
            //写审核日志
            const params = {
                auditBuId: publishid,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: this.auditOpinion,
                auditNode: "",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //驳回
        async reject() {
            if (this.auditOpinion === "OK") {
                VXETable.modal.message({
                    content: "驳回请修改默认审核意见",
                    status: "error",
                });
                return;
            }
            const type = await VXETable.modal.confirm("您确定要驳回吗?");

            if (type === "confirm") {
                const param = {
                    publishId: this.formInput.formData.Id,
                    editType: "1", //技术驳回
                    RobotType: "",
                    MachineName: this.formInput.formData.MachineName,
                    Levele: "",
                    IsEncrypt: "",
                    userId: this.$store.state.userID,
                };
                this.$api.newPublishManageAPI
                    .auditPublish(Qs.stringify(param))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        this.findData();
                        //审核记录
                        this.addAuditRecord(this.formInput.formData.Id, "2"); //2 驳回

                        VXETable.modal.message({
                            content: "驳回成功",
                            status: "success",
                        });
                        this.formInput.isShow = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //提交
        submit() {
            //console.log(this.formInput.formData)
            if (
                (this.formInput.formData.realPlatform === "PT001" ||
                    this.formInput.formData.realPlatform == "PT002" ||
                    this.formInput.formData.realPlatform == "PT005") &&
                (this.formInput.formData.MachineName == null ||
                    this.formInput.formData.MachineName == "")
            ) {
                VXETable.modal.message({
                    content: "虚拟机不能为空",
                    status: "error",
                });
                return;
            }

            if (this.auditOpinion === "") {
                VXETable.modal.message({
                    content: "审核意见不能为空",
                    status: "error",
                });
                return;
            }
            const param = {
                publishId: this.formInput.formData.Id,
                editType: "2",
                RobotType: "",
                MachineName: this.formInput.formData.MachineName,
                Levele: "",
                IsEncrypt: "",
                userId: this.$store.state.userID,
                operationNodes: this.formInput.formData.operationNodes,
                replaceNodes: this.formInput.formData.replaceNodes,
            };
            this.submitLoading = true;
            this.$api.newPublishManageAPI
                .auditPublish(Qs.stringify(param))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        this.submitLoading = false;
                        return;
                    }
                    VXETable.modal.message({
                        content: "审批成功",
                        status: "success",
                    });
                    this.findData();
                    this.addAuditRecord(this.formInput.formData.Id, "1"); //1 通过
                    //测试发布，并且是派神易就传接口
                    if (
                        this.formInput.formData.PubState == "1" &&
                        this.formInput.formData.realPlatform == "PT001"
                    ) {
                        this.addPackageQueue(this.formInput.formData.Id);
                    }

                    this.formInput.isShow = false;
                    this.submitLoading = false;
                })
                .catch((error) => {
                    VXETable.modal.message({ content: error, status: "error" });
                    this.submitLoading = false;
                    console.log(error);
                });
        },
        addPackageQueue(publishid) {
            //插入包更新队列
            const params = {
                Id: "",
                Priority: 1,
                PubId: publishid,
                HandleType: 0, //0首次 1 更新包
                Status: 0, // 待处理
                StartTime: "",
                EndTime: "",
                Creator: this.$store.state.userID,
                CreationTime: "",
                ErrorMsg: "",
                ExtraMsg: "",
            };
            this.$api.publishManageAPI
                .addPackageQueue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindAllReqPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["27"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.allReqPlatform = [];
                    for (const item of res.data.Data) {
                        this.formInput.allReqPlatform.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindTechMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getTechMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allTechs = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allTechs.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindSceneMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getSceneMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allScenes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allScenes.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDeployPlatformList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.planPlatform = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.planPlatform.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindDigitalType() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDigitalMemberTypeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.digitalTypes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.digitalTypes.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindAllStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["28"], //发布状态
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.allStatus = [];
                    for (const item of res.data.Data) {
                        if (item.LookupValueCode === "0") {
                            continue;
                        }
                        this.toolbar.allStatus.push({
                            value: item.LookupValueCode,
                            label: item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHQ() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        console.log(res.data.Message);
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.hqOptions = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.hqOptions.push({
                            value: item.hqCode,
                            label: item.hqName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        viewInstructions() {
            const a = document.createElement("a");
            a.href =
                "https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1677";
            a.target = "_blank";
            a.click();
        },
    },
    mounted() {
        this.bindHQ();
        this.bindAllStatus();
        this.bindAllReqPlatform();
        this.bindTechMember();
        this.bindSceneMember();
        this.bindPlatform();
        this.bindDigitalType();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
